var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"myVueDropzone",staticClass:"dz-dropzone dz-dropzone-card",attrs:{"id":"dropzone","options":_vm.dropzoneOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }